import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { useNavigate } from "react-router";
import { useSelector } from 'react-redux';
import { manufacturerServices } from "../../services/manufacturerServices";

const ManufacturerAdd = () => {
  const toast = useRef(null);
  const unitreducer = useSelector((state)=>state.unitreducer);
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const [units,setUnits] = useState([]);
  const [currencies,setCurrencies] = useState([]);
  const [productlist,setProductlist] = useState([]);
  const [errors, setErrors] = useState({});
  const [productnamesku, setProductnamesku] = useState('');
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    contact_person: "",
    gst_no: "",
    country: "",
    state: "",
    city: "",
    website: "",
    notes: "",
    status: "active",
  });


  useEffect(()=>{
  },[]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone || isNaN(formData.phone)) newErrors.phone = "Phone number is required";
    // if (!formData.date || isNaN(formData.date)) newErrors.date = "Created Date is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.contact_person) newErrors.contact_person = "Contact Person is required";
    if (!formData.country) newErrors.country = "Country is required";
    if (!formData.city) newErrors.city = "City is required";

    // Add other field validations as needed

    return newErrors;
  };

  const refs = {
    name: useRef(null),
    email: useRef(null),
    phone: useRef(null),
    // date: useRef(null),
    address: useRef(null),
    contact_person: useRef(null),
    country: useRef(null),
    city: useRef(null),
  };

  const handlesubmit = (e) => {
     e.preventDefault();
        const validationErrors = validate();
          setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) {
      // Focus first input with error
          const firstErrorKey = Object.keys(validationErrors)[0];
          if (refs[firstErrorKey]) {
            refs[firstErrorKey].current.focus();
          }
      return;
    }
    let dataToSend = { ...formData };
    //   if (productnamesku) {
    //     dataToSend.product_name = productnamesku;
    //   }
    setLoading(true);
        manufacturerServices.createmanufacturer(dataToSend).then((response)=>{
            if(response.status == 200){
               setLoading(false);
                toast.current.show({ severity: 'success', summary: 'manufacturer', detail: 'Manufacturer created successfully' }); 
            }else{
               setLoading(false);
                toast.current.show({ severity: 'error', summary: 'manufacturer', detail: `${response.data.data}` }); 
            }   
        }).catch((error)=>{
            setLoading(false);
            toast.current.show({ severity: 'error', summary: 'manufacturer', detail: 'Error' }); 
        });
    

    // Handle form submission here
  };

  // const getunits = () =>{
  //   unitreducer.then((response)=>{
  //       //  console.log(response);
  //        setUnits(response);
  //     }).catch((error)=>{
          
  //     });
  // }
  // const getproduct = () =>{
  //   productservices.getbulkproduct().then((response)=>{
  //     console.warn(response);
  //       if(response.status ==200){
  //           setProductlist(response.data.data);  
  //       }else{
  //           setProductlist([]); 
  //       }
         
  //     }).catch((error)=>{
  //           setProductlist([]); 
  //     });
  // }
  const handleClose = () => {
    // Handle close action here
  };

  // function displaySupplier(){
  //   let unitsarr = [];
  //   units.forEach((value,index)=>{
  //     unitsarr.push(<option value={value.short_code}>{value.name}</option>); 
  //   });

  //   return unitsarr;
  // }
//     function displaySupplier2(){
//       let supllierdata = [];
//       supllierlist.forEach((value,index)=>{
//         supllierdata.push(<option value={value.id}>{value.name}</option>); 
//       });
//       return supllierdata;
//    }

  //  const getcurrency = () => {
  //   currencyreducer.then((response)=>{
      
  //     // console.log("currency reducer");
  //     // console.log(response);
  //       setCurrencies(response);
  //     }).catch((error)=>{
  //   });
  //  } 

  //  const displayCurrency = () => {
  //   let items = [];
  //   currencies.forEach((value,index)=>{
  //      items.push(<option key={index} value={value.code}>{value.code}</option>);
  //   })  
  //   return items;
  // }


  // const gettodaydate =() =>{
  //  const date= new Date().toISOString().split('T')[0]; // e.g., "2025-06-13"
  //  setFormData({ ...formData, ['date']: date });
  // }


  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Product/addproduct"} divider={false} />
      <div class="row">
        {/* <div className='col-md-12 mb-4 mt-4'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color custom-btn-style'>Add New Product</button> 
                      <Searchbox/>
                  </div> 
              </div>  */}

        <Titlebar text={"Create Manufacturer"} />
        <div className="col-md-12 mt-3">
          <div className="card ps-5 pe-5">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>
                <form onSubmit={(e) => handlesubmit(e)}>

                        <div class="row mb-3">
                            <div class="col-md-6">
                            <label for="name" class="form-label">Name</label>
                            <input type="text"  onChange={handleChange} ref={refs.name} class="form-control" id="name" name="name" placeholder="Enter Name"/>
                             {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}
                            </div>
                            <div class="col-md-6">
                            <label for="email" class="form-label">Email</label>
                            <input type="email"  onChange={handleChange} ref={refs.email} class="form-control" id="email" name="email" placeholder="Enter Email"/>
                             {errors.email && <span style={{ color: "red" }}>{errors.email}</span>}
                            </div>
                           
                        </div>

                        <div class="row mb-3">
                          <div class="col-md-6">
                            <label for="phone" class="form-label">Phone</label>
                            <input type="number" ref={refs.phone} class="form-control" 
                            id="phone" name="phone" placeholder="Enter Phone Number"  onChange={handleChange} />
                             {errors.phone && <span style={{ color: "red" }}>{errors.phone}</span>}
                         </div>
                        <div class="col-md-6">
                            <label for="address" class="form-label">Address</label>
                            <input type="text" ref={refs.address} class="form-control" 
                            id="address" name="address" placeholder="Enter Address"  onChange={handleChange} />
                             {errors.address && <span style={{ color: "red" }}>{errors.address}</span>}
                         </div>
                        
                        
                        </div>
                         <div class="col-md-6">
                            <label for="address" class="form-label">Manufacturer Code</label>
                            <input type="text"  class="form-control" required
                            id="address" name="manufacturer_code" placeholder="Manufacturer Code"  onChange={handleChange} />
                             {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                         </div>
                        <div class="row mb-3">
                            <div class="col-md-4">
                            <label for="contact_person" class="form-label">Contact Person</label>
                            <input type="text" placeholder="Enter Contact Person" ref={refs.contact_person} class="form-control" id="contact_person" name="contact_person" value={formData.contact_person} onChange={handleChange}/>
                            {errors.contact_person && <span style={{ color: "red" }}>{errors.contact_person}</span>}
                            </div>
                            <div class="col-md-4">
                            <label for="gst_no" class="form-label">GST NO</label>
                            <input type="text"  placeholder="Enter GST NO" class="form-control" id="gst_no" name="gst_no"  onChange={handleChange}/>
                            </div>
                            <div class="col-md-4">
                            <label for="country" class="form-label">Country</label>
                            <input type="text" ref={refs.country} placeholder="Enter Country" class="form-control" id="country" name="country"  onChange={handleChange}/>
                            {errors.country && <span style={{ color: "red" }}>{errors.country}</span>}
                            </div>
                        </div>

                        <div class="row mb-3">
                            <div class="col-md-4">
                                <label for="state" class="form-label">State</label>
                                <input type="text" ref={refs.state} placeholder="Enter State" class="form-control" id="state" name="state"  onChange={handleChange}/>
                                {errors.state && <span style={{ color: "red" }}>{errors.state}</span>}
                            </div>

                            <div class="col-md-4">
                                <label for="city" class="form-label">City</label>
                                <input type="text" ref={refs.city} placeholder="Enter City" class="form-control" id="city" name="city"  onChange={handleChange}/>
                                {errors.city && <span style={{ color: "red" }}>{errors.city}</span>}
                            </div>

                            <div class="col-md-4">
                                <label for="website" class="form-label">Website</label>
                                <input type="text" ref={refs.website} placeholder="Enter Website" class="form-control" id="website" name="website"  onChange={handleChange}/>
                            </div>

                        </div>

                        <div class="row mb-3">

                          <div class="col-md-8">
                            <label for="notes" class="form-label">Remarks</label>
                            <textarea class="form-control" id="notes" name="notes" rows="3" placeholder="Enter Notes"  onChange={handleChange}></textarea>
                          </div>
                        <div class="col-md-4">
                            <label for="status" class="form-label">Status</label>
                            <select class="form-select" id="status" name="status" ref={refs.status}  onChange={handleChange}>
                               <option value="">Select Status</option> 
                                <option value="active">Active</option>
                                <option value="">Inactive</option>
                            </select>
                            {errors.status && <span style={{ color: "red" }}>{errors.status}</span>}
                            </div>
                        </div>


                    <div class="row">
                      <div class="col-md-6">
                        <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color"
                         disabled={loading}>
                         {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" />
                                        Loading...
                                    </>
                                ) : (
                                    "Save"
                                )}
                         </button></div>
                      <div class="col-md-6">
                      <button type="button" class="btn color-white w-100 rounded custom-btn-color-secondary">Close</button>
                      </div>
                      </div>
                        {/* <button type="submit" class="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">Submit</button> */}

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManufacturerAdd;
